import { ChevronLeft, ChevronRight } from 'lucide-react';

import Button from '../../Common/Button';

type PaginationProps = {
  totalquestions: number;
  pageSize: number;
  currentPage: number;
  handlePageChange: (page: number) => void;
  handlePageSizeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
};

const Pagination = ({
  totalquestions,
  pageSize,
  currentPage,
  handlePageChange,
  handlePageSizeChange
}: PaginationProps) => {
  const totalPages = Math.ceil((totalquestions || 0) / pageSize);
  const currentPageGroup = Math.floor(currentPage / 10);

  const pages = Array.from(
    { length: Math.min(10, totalPages - currentPageGroup * 10) },
    (_, i) => currentPageGroup * 10 + i
  );

  return (
    <div className='my-3 flex items-center justify-center gap-2'>
      <div className='flex items-center gap-1'>
        <Button
          label={<ChevronLeft size={20} />}
          variant='none'
          classes='rounded-full hover:bg-primary mr-1 p-0 w-6 h-full'
          handleClickBtn={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 0}
        />

        {pages.map(page => (
          <Button
            key={page}
            label={page + 1}
            variant='none'
            classes={`w-8 rounded-full ${
              currentPage === page
                ? 'bg-blue_a12 text-white'
                : 'hover:bg-blue_a12 bg-primary'
            }`}
            handleClickBtn={() => handlePageChange(page)}
          />
        ))}

        <Button
          label={<ChevronRight size={20} />}
          variant='none'
          classes='rounded-full hover:bg-primary p-0 w-6 h-full'
          handleClickBtn={() => handlePageChange(currentPage + 1)}
          disabled={currentPage >= totalPages - 1}
        />
      </div>

      <select
        value={pageSize}
        onChange={handlePageSizeChange}
        className='cursor-pointer rounded-md border border-gray-300 py-1 pl-2'
      >
        {[10, 20, 50, 100].map(size => (
          <option key={size} value={size}>
            {size} per page
          </option>
        ))}
      </select>
      {totalquestions && (
        <p>
          <span className='font-sm'>Total : </span>
          <span className='font-normal'>{totalquestions}</span>
        </p>
      )}
    </div>
  );
};

export default Pagination;
